<template>
  <router-view id="app"/>
</template>

<script>
export default { name: 'app' }
</script>

<style lang="scss">
  @font-face{
    font-family: 'Auther';
    src: url('https://haidangtravel.com/fonts/iCielAuther-Regular.eot');
    src: url('https://haidangtravel.com/fonts/iCielAuther-Regular.eot?#iefix') format('embedded-opentype'),
    url('https://haidangtravel.com/fonts/iCielAuther-Regular.woff') format('woff'),
    url('https://haidangtravel.com/fonts/iCielAuther-Regular.ttf') format('truetype'),
    url('https://haidangtravel.com/fonts/iCielAuther-Regular.svg#webfont') format('svg');
  }
@import './sass/app';
</style>



// WEBPACK FOOTER //
// src/App.vue